module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b-modal', {
    ref: "communityPermissionModal",
    attrs: {
      "id": "communityPermissionModal",
      "size": "lg",
      "title": _vm.$t('community.modal.permission'),
      "no-close-on-backdrop": ""
    },
    on: {
      "shown": _vm.setCommunityPermissions
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row font-weight-bold"
  }, [_c('div', {
    staticClass: "col col-12"
  }, [_vm._v(_vm._s(_vm.$t('community.permission.existing')))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col col-12"
  }, [_c('community-permissions', {
    attrs: {
      "communityPermissions": _vm.communityPermissions
    }
  })], 1)]), _vm._v(" "), _c('hr', {
    staticClass: "my-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "row font-weight-bold"
  }, [_c('div', {
    staticClass: "col col-12"
  }, [_vm._v(_vm._s(_vm.$t('community.permission.create')))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form', {
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.createCommunityPermission($event)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('community.permission.user.selection'),
      "state": _vm.communityPermissionCreateUserState,
      "description": _vm.$t('community.permission.user.selection.description')
    }
  }, [_c('typeahead', {
    ref: "communityPermissionCreateUserTypeahead",
    attrs: {
      "action": "searchUsers",
      "actionIndicator": "searchingUsers",
      "onHit": _vm.permissionUserSelected
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('community.permission.permission'),
      "state": _vm.communityPermissionCreatePermissionState,
      "description": _vm.$t('community.permission.permission.description')
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.communityPermissionCreatePermissionOptions
    },
    model: {
      value: (_vm.communityPermissionCreate.permission),
      callback: function($$v) {
        _vm.communityPermissionCreate.permission = $$v
      },
      expression: "communityPermissionCreate.permission"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col text-center"
  }, [_c('b-btn', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.createCommunityPermission
    }
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.create.community.permission')) + "\n                ")])], 1)])])], 1)])]), _vm._v(" "), _c('div', {
    slot: "modal-footer"
  }, [_c('div', {
    staticClass: "btn-group",
    attrs: {
      "role": "group",
      "aria-label": "Community permission actions"
    }
  }, [_c('b-btn', {
    on: {
      "click": _vm.hideCommunityPermissionModal
    }
  }, [_c('i', {
    staticClass: "fa fa-close",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.close')) + "\n        ")])], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-055aa43c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/communities/modals/CommunityPermissionModal.vue
// module id = 467
// module chunks = 0